import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-business'

type BusinessApprovalPolicyV2Response = paths['/api/business-traveller/businesses/{businessId}/approval-policies-v2/resolve']['get']['responses'][200]['content']['application/json']

type BusinessApprovalPolicyV2Result = paths['/api/business-traveller/businesses/{businessId}/approval-policies-v2/resolve']['get']['responses'][200]['content']['application/json']['result']

type ApprovalPolicyScope = App.BusinessTraveller.ApprovalPolicy['scope']

function mapPolicyV2(policy: BusinessApprovalPolicyV2Result): App.BusinessTraveller.ApprovalPolicy {
  const scopeMap: Record<BusinessApprovalPolicyV2Result['requirement'], ApprovalPolicyScope> = {
    ALWAYS: 'ALWAYS',
    NEVER: 'NEVER',
    OUT_OF_POLICY: 'OUTOFPOLICYONLY',
  }

  return {
    id: policy.id ?? '',
    name: policy.name,
    scope: scopeMap[policy.requirement],
    priceBuffer: Number(policy.priceChangeBuffer ?? 0),
  }
}

interface Params {
  businessId: string;
}

async function requestGetPolicy(params: Params): Promise<App.BusinessTraveller.ApprovalPolicy> {
  const { businessId } = params

  const policy = await requestUtils.get<BusinessApprovalPolicyV2Response>(
    `/api/business-traveller/businesses/${businessId}/approval-policies-v2/resolve`,
    { credentials: 'include' },
  )

  return mapPolicyV2(policy.result)
}

export default requestGetPolicy
